/**
 * @generated SignedSource<<84eed161ae7d2b24827b09f53071c36b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassDetailQuery$variables = {};
export type ClassDetailQuery$data = {
  readonly self: {
    readonly id: string;
  };
};
export type ClassDetailQuery = {
  response: ClassDetailQuery$data;
  variables: ClassDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "self",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassDetailQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClassDetailQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b1db8f7505b9cab03b6c03ab63bc0d02",
    "id": null,
    "metadata": {},
    "name": "ClassDetailQuery",
    "operationKind": "query",
    "text": "query ClassDetailQuery {\n  self {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eed1f5740dae961631b03b27db01f8d0";

export default node;
